import type { InteractionType } from '~/model/InteractionType';
import { ResizedImg } from '~/components/commons/ResizedImg/ResizedImg';

export const AnnouncementPicture = ({
  interaction: {
    media,
  },
}: {
  interaction: InteractionType;
}) => {
  return media
    ? (
        <div className="announcement__medias">
          <div className="announcement__picture">
            <ResizedImg
              alt=""
              format="768x0"
              fill
              sizes="(max-width: 768) 100vw, 768px"
              style={{ objectFit: 'cover' }}
              src={media.content_url}
            />
          </div>
        </div>
      )
    : null;
};
